import JuryDetail from "@/models/jury-detail";
// import StatusProposal from "@/models/status-proposal";
import TeamHeader from "@/models/team-header";
import { UUIDModel } from "@/models/uuid-model";
import { UUID } from "@/models/uuid";
import ProposalDetail from "@/models/proposal-detail";
import CommentHeader from "@/models/comment-header";
import Voting from "@/models/voting";
import { Topic } from "@/dto/proposal.dto";

export enum Status {
  Registered = "Registered",
  Finalized = "Finalized",
  Approved = "Approved",
  Rejected = "Rejected",
}

class Proposal extends UUIDModel<Proposal> {
  public id: UUID = new UUID();
  public phase = 0;
  public proposalTitle = "";
  public category = "";
  public createdAt = "";
  public summary = "";
  public keyword = "";
  public createdBy = "";
  public approvedAt = "";
  public finalizedAt = "";
  public finalizedBy = "";
  public order = 0;
  public score = 0;
  public juryDetail: JuryDetail[] = [];
  public proposalDetails: ProposalDetail[] = [];
  public commentHeader: CommentHeader[] = [];
  public voting: Voting[] = [];
  public isCanEntry = false;
  public currentUserRoles: any[] = [];
  public previousYearProposal: {
    id: string;
    proposalTitle: string;
    projectCode: string;
  } | null = null;

  public projectDuration = 0;
  public topics: Topic[] = [];

  public teamId: UUID = new UUID();
  public team: TeamHeader = new TeamHeader();

  public status: Status = Status.Registered;

  public isRegisteredForIA = false;
  public isTermsConditionAccepted = false;

  // public statusId: UUID = new UUID();
  // public status: StatusProposal = new StatusProposal();

  public constructor(props?: Partial<Proposal>) {
    super();
    Object.assign(this, props);
  }

  public previousYearProposalLabel(): string {
    const p = this.previousYearProposal;
    const code = this.previousYearProposal!.projectCode;
    const title = this.previousYearProposal!.proposalTitle;

    if (p == null) return "No";
    else return code === "-" ? title : code + " - " + title;
  }
}

export default Proposal;
